import React, { useState } from 'react'
import SettingIntergration from '../Components/widgets/SettingIntergration';
import SettingMessages from '../Components/widgets/SettingMessages';
import SettingBilling from '../Components/widgets/SettingBilling';
import SettingGeneral from '../Components/widgets/SettingGeneral';
import { useSelector } from 'react-redux';

function Settings() {
   const [activeTab, setActiveTab]                     = useState("general"); //billing // messages// Integrations
   const {user}                                        = useSelector((state) => state.auth);

   const renderTabContent = () => {
    switch (activeTab) {
      case "general":
        return <SettingGeneral user={user} />;
      case "billing":
        return <SettingBilling user={user} />;
      case "messages":
        return <SettingMessages user={user} />;
      case "integrations":
        return <SettingIntergration user={user} />;
      default:
        return null;
    }
  };

  return (
    <div className="card">
      <div className="card-body">
        <h3 class="inner-part">Settings</h3>
        <div className="row">
          {/* Sidebar Navigation */}
          <div className="col-md-3">
            <ul className="nav flex-column nav-pills">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "general" ? "active" : ""}`}
                  onClick={() => setActiveTab("general")}
                >
                  General
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "billing" ? "active" : ""}`}
                  onClick={() => setActiveTab("billing")}
                >
                  Billing
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "messages" ? "active" : ""}`}
                  onClick={() => setActiveTab("messages")}
                >
                  Messages
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "integrations" ? "active" : ""}`}
                  onClick={() => setActiveTab("integrations")}
                >
                  Integrations
                </button>
              </li>
            </ul>
          </div>

          {/* Tab Content */}
          <div className="col-md-9">
            <div className="tab-content p-3 border rounded">
              {renderTabContent()}
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Settings